import { render, staticRenderFns } from "./CheckSpecialOfferReceipt.vue?vue&type=template&id=6b6ed94b&scoped=true&"
import script from "./CheckSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
export * from "./CheckSpecialOfferReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./CheckSpecialOfferReceipt.vue?vue&type=style&index=0&id=6b6ed94b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ed94b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
